// @flow
import * as React from 'react';
import {useParams} from "react-router-dom";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import {GiTwoCoins} from "react-icons/gi";
import {
    TbArrowBadgeLeft,

    TbSquareRoundedMinus,
    TbSquareRoundedPlusFilled
} from "react-icons/tb";

import {useNavigate} from "react-router-dom";


const currencyFormat = Intl.NumberFormat('en-US');
export default function VendorProducts() {
    const navigate = useNavigate();
    const {oid , id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [vendor, setVendor] = React.useState([]);
    const [products, setProducts] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [totalPrice, setTotalPrice] = React.useState(parseInt(window.localStorage.getItem("totalPrice")));
    const [cart, setCart] = React.useState([]);

    React.useEffect(() => {
       // document.body.style.background = '#424242';
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let vendor = window.localStorage.getItem("vendor");
        if (vendor !== id) {
            cartItems = null;
        }
        if (cartItems) {
            setCart(cartItems)
        }
        let params = { };
        if(window.localStorage.getItem("fromSearch")) {
             params = {
                search: window.localStorage.getItem("searchTerm")
            }
            setSearch(window.localStorage.getItem("searchTerm"))
        }
        else {

        }

        API.getVendor2(id, params)
            .then((response) => {
                setVendor(response.data);
                setProducts(response.data.products)
                setIsLoaded(true);
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)
    }, [id]);

    const onPlusClick = (productID, price) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let vendor = window.localStorage.getItem("vendor");
        setTotalPrice(totalPrice + price)
        window.localStorage.setItem("totalPrice", totalPrice + price);

        if (vendor !== id) {
            cartItems = null;
            setTotalPrice(price)
            window.localStorage.setItem("totalPrice", price);
        }
        let count = 1;
        if (cartItems) {
            const find_item = cartItems.find(x => x.item === productID);
            if (find_item) {
                count = find_item.count + 1;
                const objIndex = cartItems.findIndex((obj => obj.item === productID));
                cartItems[objIndex].count = count;
            } else {
                cartItems.push({'item': productID, 'count': count})
            }
        }
        if (!cartItems) { //Object.keys(this.state.markets).length < 1
            cartItems = [];
            cartItems.push({'item': productID, 'count': count})
        }
        setCart(cartItems);
        window.localStorage.setItem("cart", JSON.stringify(cartItems));
        window.localStorage.setItem("vendor", id);
        window.localStorage.setItem("companyName", vendor.title);

        /*      setProducts(products.map((product) => {
                  if (product.id === productID) {
                      if(product.count > 0) {
                          product.count += 1;
                      }
                      else {
                          product.count = 1;
                      }

                   /!*   this.setState({sum_product_selected: this.state.sum_product_selected + 1 ,sum_price: this.state.sum_price + +product.discounted_price })*!/
                  }
                  return product;
              }));*/

    }

    const onMinusClick = (productID, price) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        setTotalPrice(totalPrice - price)
        window.localStorage.setItem("totalPrice", totalPrice - price);

        if (cartItems) {
            const find_item = cartItems.find(x => x.item === productID);
            if (find_item) {
                const count = find_item.count;
                const objIndex = cartItems.findIndex((obj => obj.item === productID));
                if (count > 1) {
                    cartItems[objIndex].count = count - 1;
                } else {
                    cartItems.splice(objIndex, 1)
                }
                setCart(cartItems)
                window.localStorage.setItem("cart", JSON.stringify(cartItems));
            }
        }

    }

    const getItemCartCount = (productID) => {
        const find_item = cart.find(x => x.item === productID);
        if (find_item) {
            return (find_item.count)
        } else {
            return 0
        }
    }

    const onSearchProducts = (event) => {

        setSearch(event.target.value);
        window.localStorage.removeItem("fromSearch");
        if (event.target.value.length > 3) {
            setIsLoaded(false);
            const params = {
                search: event.target.value
            }
            API.getVendor2(id, params)
                .then((response) => {
                    setVendor(response.data);
                    setProducts(response.data.products)
                    setIsLoaded(true);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        } else if (event.target.value.length < 1) {
            setIsLoaded(false);
            const params = {}
            API.getVendor2(id, params)
                .then((response) => {
                    setVendor(response.data);
                    setProducts(response.data.products)
                    setIsLoaded(true);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }

    }


    const onContinueClick = () => {
        setIsLoaded(false);
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let vendorID = window.localStorage.getItem("vendor");

        const request = {
            cart: cartItems,
            vendor_id: vendorID,
            id: oid
        }

        API.editOrder(request,id)
            .then((response) => {
                toast.success(response.message);

                setTimeout(() => {
                    window.location.replace(`/order/${oid}`); //${response.data.id}
                }, 1500)
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }


    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header hasBack={true} title='ویرایش فاکتور' />
            <section className="container   rtl p-md-5 m-md-4 products-list ">

                <div className="row mx-1 mt-2 mx-2">


                    <div className="col-12 mt-2">
                        <div className='bg-custom py-3 my-2 rounded mx-3'>
                            <input type="text" className="w-100 rounded border-0 bg-white text-small-3 p-2"
                                   placeholder="جستجوی کالا بر اساس عنوان"
                                   value={search}
                                   onChange={onSearchProducts}
                            />
                        </div>
                    </div>
                </div>

            </section>

            <section className="container px-md-5 mx-md-5  rtl pb-5 ">

                {
                    isLoaded && products.map(product => {
                        const price = product.vendor_price.discounted_price
                    return (
                        <div className="row vendor-product mx-2 py-2"

                             key={product.id}
                        >
                            <div className="col-3 p-1">
                                <img src={product.cover_image} alt={product.name}
                                     onClick={() => {

                                         window.localStorage.setItem("companyName", vendor.title);
                                         navigate(`/vendor/${id}/${product.id}`)
                                     }


                                }

                                />

                            </div>
                            <div className="col-9 p-1">
                                <div className="fw-bold">
                                    {product.name}

                                </div>


                                {product.vendor_price.price ?
                                    <div className="text-small-1 pe-3 mt-2 text-muted fw-bold">
                                        <GiTwoCoins className='ms-2 '/>
                                        قیمت سوپری:
                                        &nbsp;
                                        &nbsp;
                                        {
                                            product.vendor_price.discount_percent > 0 &&
                                            <span
                                                className='text-decoration-line-through fw-normal text-small-3 px-2 '>
                                                       {currencyFormat.format(product.vendor_price.price)}

                                            </span>
                                        }
                                        {currencyFormat.format(price)}
                                        &nbsp;
                                        <span className='text-small-3 text-muted'>ریال</span>
                                        &nbsp;
                                    </div>
                                    : ''
                                }

                                {product.vendor_price.wholesale_discounted_price ?
                                    <div className="text-small-4 pe-3 mt-2 text-muted">
                                        <GiTwoCoins className='ms-2 '/>
                                        قیمت عمده:
                                        &nbsp;
                                        (
                                        بیشتر از
                                        &nbsp;
                                        {
                                            product.vendor_price.wholesale_amount
                                        }
                                        &nbsp;
                                        {
                                           product.counting_unit?.title
                                        }
                                        )
                                        :
                                        &nbsp;
                                        {currencyFormat.format(product.vendor_price.wholesale_discounted_price)}
                                        <span className='text-small-3'>
                                                    &nbsp;
                                            ریال
                                            &nbsp;
                                                    </span>
                                    </div>
                                    : ''
                                }
                            </div>
                            <div className="col-12 px-2 mx-0 mt-0 ">


                                <div className="add-minus-products text-start">

                                    {
                                        getItemCartCount(product.id) > 0 ?
                                            <span className="add-product-icon text-secondary "
                                                  onClick={() => {
                                                      onMinusClick(product.id, price);

                                                  }}>
                                         <TbSquareRoundedMinus/>

                                     </span> : <span>&nbsp;</span>
                                    }

                                    {
                                        getItemCartCount(product.id) > 0 ?
                                            <span className="px-2">
                                    <input type="tel" className="bg-white" value={getItemCartCount(product.id)}
                                           readOnly/>
                                </span> : <span>&nbsp;</span>
                                    }

                                    <span className="add-product-icon   "
                                          onClick={() => {
                                              onPlusClick(product.id, price);

                                          }}>
                                         <TbSquareRoundedPlusFilled className='text-secondary-color'/>
                                    </span>
                                </div>
                            </div>
                        </div>
                    );

                    }
                )
                }
                {
                    cart.length > 0 ?
                        <div className="row">
                            <div className="col-12 p-2 fixed-bottom max-w-lg">
                                <button
                                    className="btn btn-success bg-secondary-color text-end text-small-1 text-semi-big  w-100 p-2  pe-4 border-0"
                                    onClick={onContinueClick}
                                >
                                    ویرایش فاکتور
                                    <span className="badge  p-2 float-start">

<TbArrowBadgeLeft className='text-big-3'/>
                    </span>
                                </button>
                            </div>
                        </div>
                        : ''
                }

            </section>
            <div className='py-5'>
                &nbsp;
            </div>

        </React.Fragment>
    );
}